import { useEffect, useState } from "react";
import { collection, onSnapshot, deleteDoc, doc } from "firebase/firestore";
import db from "../../firebase/firebase";
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardText,
    Button
} from "reactstrap";
import { useNavigate } from 'react-router-dom';

export default function FractureQuizList() {
    const [cases, setCases] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const unsub = onSnapshot(collection(db, "fracture-quiz"), (snap) => {
            const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
            data.sort((a, b) => (a.category || "").localeCompare(b.category || "") || (a.id || "").localeCompare(b.id || "", undefined, { numeric: true, sensitivity: 'base' }));
            setCases(data);
        });
        return unsub;
    }, []);

    const deleteCase = async (id) => {
        if (window.confirm("Delete this case?")) {
            await deleteDoc(doc(db, "fracture-quiz", id));
        }
    }

    const onEdit = (quizCase) => {
        navigate('/admin/add-fracture-quiz', { state: { quizCase: quizCase } });
    }

    return (
        <div className='main admin-fracture-page'>
            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Fracture Quiz Cases
                </div>
            </div>
            <Button
                className='btn-block btn-dark'
                style={{ alignSelf: 'center', marginTop: 10, fontSize: 18, fontWeight: 'bold', width: '100%', backgroundColor: 'green', borderWidth: 0, height: 40, width: 300 }}
                onClick={() => onEdit(null)}>
                Add Case
            </Button>

            <div className='admin-fracture-grid'>
                {cases.map((c) => (
                    <div key={c.id} className='admin-fracture-card-wrap'>
                        <Card className="admin-fracture-card">
                            <CardBody>
                                <CardTitle tag="h5">{c.title || c.id}</CardTitle>
                                <CardText className="text-muted">
                                    {c.category || "No Category"}
                                </CardText>
                                <CardText>
                                    <small>{(c.scenario || "").substring(0, 50)}...</small>
                                </CardText>
                                <div className="d-flex gap-2">
                                    <Button size="sm" color="secondary" onClick={() => onEdit(c)}>
                                        Edit
                                    </Button>
                                    <Button size="sm" color="danger" onClick={() => deleteCase(c.id)}>
                                        Delete
                                    </Button>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                ))}
            </div>
        </div>
    );
}
